export const MODULE_NAME = 'publications.storage.files-history'
